<template>
	<footer
		class="footer"
		:style="cssVars"
	>
		<div class="upper container">
			<a
				href="/"
				class="brand_mob"
				v-if="window.width <= 1024"
			><img
					:src="
            parsedGlobalSettings.footer.footer_logo
              ? parsedGlobalSettings.footer.footer_logo.url
              : this.logo
          "
					alt="Electranet"
					height="50"
				/></a>

			<div class="footer_col one" v-if="window.width > 1024">
				<a
					href="/"
					class="brand"
					v-if="window.width > 1024"
				><img
						:src="
              parsedGlobalSettings.footer.footer_logo
                ? parsedGlobalSettings.footer.footer_logo.url
                : this.logo
            "
						alt="Electranet"
						height="50"
					/></a>

			</div>

			<!-- <div class="footer_col two"></div> -->

			<div class="footer_col three" v-if="window.width > 1024">

			</div>

			<div class="footer_col four">
				<div
					class="contact_address"
					v-if="parsedGlobalSettings.footer.contact_address"
					v-html="parsedGlobalSettings.footer.contact_address"
				></div>

				<ul
					v-if="parsedGlobalSettings.footer.social_channels"
					class="socials"
				>
					<template v-for="(channel, index) in parsedGlobalSettings.footer
                .social_channels">
						<li
							v-if="channel.url != false"
							:key="index"
						>
							<a
								:href="channel.url.url"
								:target="channel.url.target"
							><img
									v-if="channel.icon != false"
									:src="channel.icon.url"
									:alt="index"
								/></a>
						</li>
					</template>
				</ul>
			</div>
		</div>
		<div class="lower container">

			<div class="inner">
				<div class="left">

					<!-- <menu-item
						v-if="parsedGlobalSettings.general.built_by && window.width <= 1024"
						:menu_item="parsedGlobalSettings.general.built_by"
						:has-children="
              parsedGlobalSettings.general.built_by.children ? true : false
            "
						:selected="
              parsedGlobalSettings.general.built_by.object_id == current_id
            "
					></menu-item> -->

				</div>

				<div class="center">

					<span
						v-if="parsedGlobalSettings.general.built_by && window.width <= 1024"
						class="sep"
					>|</span>

					<menu-item
						v-if="parsedGlobalSettings.general.privacy_policy"
						:menu_item="parsedGlobalSettings.general.privacy_policy"
						:has-children="
              parsedGlobalSettings.general.privacy_policy.children
                ? true
                : false
            "
						:selected="
              parsedGlobalSettings.general.privacy_policy.object_id ==
              current_id
            "
					></menu-item>

					<span
						v-if="parsedGlobalSettings.general.privacy_policy"
						class="sep"
					>|</span>

					<span class="copyright">&copy;{{ getTheYear }} Copyright</span>

				</div>

				<div
					class="right"
					v-if="window.width > 1024"
				>

					<!-- <menu-item
						v-if="parsedGlobalSettings.general.built_by"
						:menu_item="parsedGlobalSettings.general.built_by"
						:has-children="
              parsedGlobalSettings.general.built_by.children ? true : false
            "
						:selected="
              parsedGlobalSettings.general.built_by.object_id == current_id
            "
					></menu-item> -->
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
import MenuItem from './MenuItem.vue';

export default {
	data() {
		return {
			window: {
				width: 0,
				height: 0,
			},
		};
	},

	props: {
		logo: {},
		footer_menu: {},
		footer_menu_two: {},
		footer_nav_bottom: {},
		current_id: {
			type: Number,
			default: -1,
		},
		global_settings: {},
		asset_url: {},
		built_by: {},
		privacy_policy: {},
	},

	computed: {
		parsedGlobalSettings() {
			if (this.global_settings) {
				return JSON.parse(this.global_settings);
			} else {
				return null;
			}
		},

		parsedFooterMenu() {
			if (this.footer_menu) {
				return JSON.parse(this.footer_menu);
			} else {
				return null;
			}
		},

		parsedFooterMenuTwo() {
			if (this.footer_menu_two) {
				return JSON.parse(this.footer_menu_two);
			} else {
				return null;
			}
		},

		parsedFooterBottom() {
			if (this.footer_nav_bottom) {
				return JSON.parse(this.footer_nav_bottom);
			} else {
				return null;
			}
		},

		getTheYear() {
			var d = new Date();
			var n = d.getFullYear();
			return n;
		},

		cssVars() {
			return {
				'--spacer': '24px',
				'--spacer-mobile': '16px',
				'--gutter-mobile': '24px',
				'--gutter-tablet-desktop': '24px',
				'--body-font-size': '16px/22px',
				'--max-width': '1440px',
			};
		},
	},

	watch: {},

	methods: {
		getFullUrl(arg) {
			let assetUrl = this.asset_url;
			return assetUrl + arg + '.svg';
		},

		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},
	},

	components: {
		MenuItem,
	},

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('resize', this.handleResize);
		this.handleResize();
	},

	mounted() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	change() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.footer {
	padding: 40px 0;
	background: var(--dark-green);
	border-top: 8px solid var(--clay-brown);
	overflow: hidden;

	@media (max-width: $mobile-xl) {
		padding: 32px 0;
	}

	/* .container {
		max-width: var(--max-width);
		margin: 0 auto;
		padding: 0 calc((100% - var(--max-width)) / 2);
		display: grid;
		grid-template-columns: repeat(12, 1fr);
		column-gap: var(--gutter-tablet-desktop);
		height: max-content;

		@media (max-width: 1920px) {
			max-width: var(--max-width);
			column-gap: var(--gutter-tablet-desktop);
		}

		@media (max-width: 1490px) {
			max-width: calc(100% - calc(var(--gutter-mobile) * 2));
			column-gap: var(--gutter-tablet-desktop);
		}

		@media (max-width: $mobile-xl) {
			max-width: calc(100% - calc(var(--gutter-mobile) * 2));
			column-gap: var(--gutter-mobile);
		}

		@media (max-width: $mobile-xl) {
			grid-template-columns: repeat(4, 1fr);
			padding: 0 var(--gutter-mobile);
		}
	} */

	.upper {
		@media (max-width: $mobile-xl) {
			row-gap: 40px;
			margin-bottom: 0;
		}

		&.container {
			column-gap: 24px;
		}

		.brand_mob {
			width: 100%;
			display: flex;
			margin-bottom: 0;

			@media (max-width: $mobile-xl) {
				justify-content: flex-start;
				align-items: center;
				width: 100%;
				grid-column: 1 / span 4;
				margin-bottom: 0;
			}

			img {
				height: 230px;

				@media (max-width: $mobile-xl) {
					height: unset;
					width: 100%;
					padding: 0;
				}
			}
		}

		.footer_col {
			grid-column: span 3;
			color: var(--white);

			@media (max-width: $mobile-xl) {
				grid-column: span 4;
				padding: 0 var(--gutter-tablet-desktop);
				/* border-top: var(--border-bright); */
			}

			.brand {
				width: 100%;
				display: flex;
				margin-bottom: 32px;

				@media (max-width: $mobile-xl) {
					justify-content: flex-start;
				}

				img {
					height: 230px;

					@media (max-width: $mobile-xl) {
						height: 230px;
						padding: 0 0;
					}
				}
			}

			&::v-deep {
				h4 {
					margin: 0 0 24px;
					color: var(--white);

					@media (max-width: $mobile-xl) {
						font: normal normal bold 20px/24px var(--primary-font-family);
					}
				}

				h3 {
					color: var(--white);
					font: normal normal 600 var(--body-font-size)
						var(--primary-font-family);
					text-transform: uppercase;
					margin: 24px 0 8px;

					@media (max-width: $mobile-xl) {
						margin: 16px 0 0;
					}

					&:first-of-type {
						margin: 0 0 8px;

						@media (max-width: $mobile-xl) {
							margin: 0 0 0;
						}
					}
				}

				p {
					font: normal normal normal 16px/24px var(--primary-font-family);
					margin: 0;
					margin: 0 0 16px;
					color: var(--white);
				}

				a {
					color: var(--white);
					font: normal normal normal 16px/24px var(--primary-font-family);
					text-decoration: none;

					&:hover {
						text-decoration: underline;
					}
				}

				h5 {
					margin: 0;
				}
			}

			&.one {
				grid-column: span 6;
				/* grid-column: span 5;

				@media (max-width: $mobile-xl) {
					grid-column: span 4;
					margin-bottom: 0;
				} */

				&::v-deep {
					h5 {
						margin: 0;
					}
				}

				@media (max-width: $mobile-xl) {
					grid-column: 1 / span 4;
					padding: 0 0 0;
					order: 0;
					border-top: 0;
				}
			}

			&.two {
				/* grid-column: 7 / span 6;
				display: grid;
				grid-template-columns: 1fr 1fr 1fr;
				grid-template-rows: auto 1fr; */
				/* column-gap: 100px; */

				@media (max-width: $mobile-xl) {
					/* grid-column: span 4; */
					padding: 0;
					order: 1;
					justify-content: flex-start;
					flex-direction: column;
					grid-template-columns: 1fr 1fr;
				}

				.social {
					@media (max-width: $mobile-xl) {
						grid-column: span 2;
						border-top: var(--border-bright);
						padding-top: 24px;
						display: flex;
						flex-direction: row;
						justify-content: center;
						align-items: center;
						gap: 24px;
					}
				}

				ul {
					grid-column: span 1;
					padding: 0;
					margin: 0;
					display: flex;
					flex-direction: column;
					row-gap: 0;
					list-style: none;
					gap: 24px;
					margin-bottom: 24px;

					@media (max-width: $mobile-xl) {
						margin-bottom: 32px;
					}

					li {
						&::v-deep {
							height: unset;

							.parent_container {
								padding: 0;
							}

							a,
							label,
							h5 {
								color: var(--white);
								font: normal normal normal 16px/24px var(--primary-font-family);
								text-transform: capitalize;

								&::before {
									display: none;
								}

								&:hover {
									text-decoration: underline;
								}
							}
						}
					}

					&.two {
						grid-column: 1 / span 4;

						li {
							&::v-deep {
								height: unset;

								.parent_container {
									padding: 0;
									justify-content: flex-start;
									gap: 10px;
								}
							}
						}
					}
				}

				h5 {
					color: var(--white);
					margin-bottom: 25px;

					@media (max-width: $mobile-xl) {
						margin-bottom: 0;
						font: normal normal normal 18px/22px var(--primary-font-family);
						text-transform: capitalize;
					}
				}

				.socials {
					grid-column: span 1;
					list-style: none;
					display: flex;
					flex-direction: row;
					padding: 0;
					margin: 0;
					width: 100%;
					gap: 16px;

					@media (max-width: $mobile-xl) {
						/* border-top: var(--border-bright); */
						/* padding-top: 24px; */
						justify-content: flex-start;
						width: unset;
					}

					a {
						display: flex;
						height: 24px;

						img {
							height: 24px;
						}
					}
				}
			}

			&.three {
				grid-column: span 3;

				@media (max-width: $mobile-xl) {
					grid-column: 1 / span 4;
					padding: 0;
					justify-content: flex-start;
					flex-direction: column;
					grid-template-columns: 1fr 1fr;
				}

				.contact_address {
					&::v-deep {
						b,
						strong {
							color: var(--electric-yellow);
							font: normal normal normal 16px/24px var(--primary-font-family);
							display: inline-flex;
							margin-bottom: 8px;
						}
						p {
							&:last-of-type {
								margin-bottom: 0;
							}
						}
					}

					@media (max-width: $mobile-xl) {
						display: grid;
						grid-template-columns: 1fr 1fr;
					}
				}
			}

			&.four {
				grid-column: span 3;

				@media (max-width: $mobile-xl) {
					grid-column: 1 / span 4;
					padding: 0;
					justify-content: flex-start;
					flex-direction: column;
					grid-template-columns: 1fr 1fr;
					padding-top: 24px;
					padding-bottom: 24px;

					.contact_address {
						text-align: center;
					}
				}

				ul {
					list-style: none;
					padding: 0;
					display: grid;
					grid-template-columns: 1fr 1fr;
					grid-template-rows: auto;
					gap: 16px;

					li {
						&::v-deep {
							.parent_container {
								padding: 0;

								a {
									&:hover {
										color: var(--white);
									}
								}
							}
						}
					}
				}
			}

			.aoc {
				display: flex;
				gap: 75px;
				color: var(--white);

				&::v-deep {
					font: normal normal normal 16px/24px var(--primary-font-family);

					p {
						font: normal normal normal 16px/24px var(--primary-font-family);
						color: var(--white);
					}
				}
			}

			ul.socials {
				list-style: none;
				padding: 0;
				display: flex;
				flex-direction: row;
				gap: 16px;
				justify-content: flex-start;
				align-items: center;
				margin-top: 60px;

				@media (max-width: $mobile-xl) {
					margin-top: 36px;
					justify-content: center;
				}

				li {
					a {
						display: flex;
					}
				}
			}
		}
	}

	.lower {
		margin-top: 0;
		padding-top: 25px;

		@media (max-width: $mobile-xl) {
			margin-top: 0;
			padding-top: 0;
		}

		.container {
			height: unset;
		}

		.inner {
			grid-column: span 12;
			display: grid;
			grid-template-columns: 1fr auto 1fr;
			gap: 16px;
			border-top: var(--border-bright);
			padding-top: 16px;

			@media (max-width: $mobile-xl) {
				grid-column: span 4;
				display: flex;
				flex-wrap: wrap;
				gap: 24px;
				align-items: center;
				padding-top: 24px;
				justify-content: center;
			}

			.left {
				display: flex;
				flex-direction: row;
				gap: 16px;
				justify-content: flex-start;

				@media (max-width: $mobile-xl) {
					grid-column: span 4;
					display: flex;
					flex-wrap: wrap;
					gap: 16px;
					align-items: center;
					justify-content: center;
				}

				ul {
					grid-column: span 1;
					list-style: none;
					padding: 0;
					margin: 0;
					display: flex;
					flex-direction: row;
					align-items: center;
					gap: 24px;

					@media (max-width: $mobile-xl) {
						flex-wrap: wrap;
						grid-column: span 4;
						justify-content: flex-start;
						flex-direction: row;
						row-gap: var(--gutter-mobile);
					}

					li {
						color: var(--white);
						height: auto;

						&::v-deep {
							.parent_container {
								padding: 0;
							}
						}

						a {
							color: var(--white);
							text-decoration: none;
							font: normal normal normal 16px/24px var(--primary-font-family);
							transition: 0.2s ease all;
							border-bottom: 2px solid transparent;
							padding-bottom: 10px;

							&:hover {
								text-decoration: underline;
							}
						}

						&.selected {
							a {
								font-weight: bold;
							}
						}
					}
				}

				p {
					color: var(--white);
					font: normal normal normal 16px/24px var(--primary-font-family);
					margin: 0;
				}

				.sep {
					color: var(--white);
					/* @media (max-width: $mobile-xl) {
						display: none;
					} */
				}

				.copyright {
					grid-column: span 1;
					display: flex;
					flex-direction: row;
					justify-content: center;
					align-items: center;
					gap: 8px;
					color: var(--white);
					font: normal normal normal 14px/20px var(--primary-font-family);

					&::before {
						display: none;
					}

					@media (max-width: $mobile-xl) {
						grid-column: span 4;
						justify-content: flex-start;
					}

					.menu_item__parent {
						&::v-deep {
							> div {
								padding: 0;
							}
						}
					}
				}

				.menu_item__parent {
					grid-column: span 1;
					justify-content: flex-end;
					height: unset;

					@media (max-width: $mobile-xl) {
						grid-column: span 4;
						justify-content: center;
					}

					&::v-deep {
						svg {
							path {
								fill: var(--white);
							}
						}

						.menu_item__parent__primary_link {
							font: normal normal normal 16px/24px var(--primary-font-family);
							color: var(--white);

							h5 {
								color: var(--white);
								font: normal normal normal 16px/24px var(--primary-font-family);
								text-transform: capitalize;
							}

							&:hover {
								text-decoration: underline;
							}

							&::before {
								display: none;
							}
						}

						> div {
							padding: 0;
						}
					}
				}
			}
			.center {
				display: flex;
				flex-direction: row;
				gap: 16px;
				justify-content: center;

				@media (max-width: $mobile-xl) {
					grid-column: span 4;
					display: flex;
					flex-wrap: wrap;
					gap: 16px;
					align-items: center;
					justify-content: center;
				}

				&.abn-acn {
					span {
						color: var(--white);
						font: normal normal normal 14px/20px var(--primary-font-family);
					}
				}

				ul {
					grid-column: span 1;
					list-style: none;
					padding: 0;
					margin: 0;
					display: flex;
					flex-direction: row;
					align-items: center;
					gap: 24px;

					@media (max-width: $mobile-xl) {
						flex-wrap: wrap;
						grid-column: span 4;
						justify-content: flex-start;
						flex-direction: row;
						row-gap: var(--gutter-mobile);
					}

					li {
						color: var(--white);
						height: auto;

						&::v-deep {
							.parent_container {
								padding: 0;
							}
						}

						a {
							color: var(--white);
							text-decoration: none;
							font: normal normal normal 16px/24px var(--primary-font-family);
							transition: 0.2s ease all;
							border-bottom: 2px solid transparent;
							padding-bottom: 10px;

							&:hover {
								text-decoration: underline;
							}
						}

						&.selected {
							a {
								font-weight: bold;
							}
						}
					}
				}

				p {
					color: var(--white);
					font: normal normal normal 16px/24px var(--primary-font-family);
					margin: 0;
				}

				.sep {
					color: var(--white);
					/* @media (max-width: $mobile-xl) {
						display: none;
					} */
				}

				.copyright {
					grid-column: span 1;
					display: flex;
					flex-direction: row;
					justify-content: center;
					align-items: center;
					gap: 8px;
					color: var(--white);
					font: normal normal normal 14px/20px var(--primary-font-family);

					&::before {
						display: none;
					}

					@media (max-width: $mobile-xl) {
						grid-column: span 4;
						justify-content: flex-start;
					}

					.menu_item__parent {
						&::v-deep {
							> div {
								padding: 0;
							}
						}
					}
				}

				.menu_item__parent {
					grid-column: span 1;
					justify-content: flex-end;
					height: unset;

					@media (max-width: $mobile-xl) {
						grid-column: span 4;
						justify-content: center;
					}

					&::v-deep {
						svg {
							path {
								fill: var(--white);
							}
						}

						.menu_item__parent__primary_link {
							font: normal normal normal 14px/20px var(--primary-font-family);
							color: var(--white);
							text-transform: unset;

							h5 {
								color: var(--white);
								font: normal normal normal 14px/20px var(--primary-font-family);
								text-transform: capitalize;
							}

							&:hover {
								text-decoration: underline;
							}

							&::before {
								display: none;
							}
						}

						> div {
							padding: 0;
						}
					}
				}
			}
			.right {
				display: flex;
				flex-direction: row;
				gap: 16px;
				justify-content: flex-end;

				@media (max-width: $mobile-xl) {
					grid-column: span 4;
					display: flex;
					flex-wrap: wrap;
					gap: 16px;
					align-items: center;
					justify-content: center;
				}

				ul {
					grid-column: span 1;
					list-style: none;
					padding: 0;
					margin: 0;
					display: flex;
					flex-direction: row;
					align-items: center;
					gap: 24px;

					@media (max-width: $mobile-xl) {
						flex-wrap: wrap;
						grid-column: span 4;
						justify-content: flex-start;
						flex-direction: row;
						row-gap: var(--gutter-mobile);
					}

					li {
						color: var(--white);
						height: auto;

						&::v-deep {
							.parent_container {
								padding: 0;
							}
						}

						a {
							color: var(--white);
							text-decoration: none;
							font: normal normal normal 14px/20px var(--primary-font-family);
							transition: 0.2s ease all;
							border-bottom: 2px solid transparent;
							padding-bottom: 10px;

							&:hover {
								text-decoration: underline;
							}
						}

						&.selected {
							a {
								font-weight: bold;
							}
						}
					}
				}

				p {
					color: var(--white);
					font: normal normal normal 16px/24px var(--primary-font-family);
					margin: 0;
				}

				.sep {
					color: var(--white);
					/* @media (max-width: $mobile-xl) {
						display: none;
					} */
				}

				.copyright {
					grid-column: span 1;
					display: flex;
					flex-direction: row;
					justify-content: center;
					align-items: center;
					gap: 8px;
					color: var(--white);
					font: normal normal normal 14px/20px var(--primary-font-family);

					&::before {
						display: none;
					}

					@media (max-width: $mobile-xl) {
						grid-column: span 4;
						justify-content: flex-start;
					}

					.menu_item__parent {
						&::v-deep {
							> div {
								padding: 0;
							}
						}
					}
				}

				.menu_item__parent {
					grid-column: span 1;
					justify-content: flex-end;
					height: unset;

					@media (max-width: $mobile-xl) {
						grid-column: span 4;
						justify-content: center;
					}

					&::v-deep {
						svg {
							path {
								fill: var(--white);
							}
						}

						.menu_item__parent__primary_link {
							font: normal normal normal 14px/20px var(--primary-font-family);
							color: var(--white);

							h5 {
								color: var(--white);
								font: normal normal normal 14px/20px var(--primary-font-family);
								text-transform: capitalize;
							}

							&:hover {
								text-decoration: underline;
							}

							&::before {
								display: none;
							}
						}

						> div {
							padding: 0;
						}
					}
				}
			}

			.left {
				@media (max-width: $mobile-xl) {
					width: 100%;
					padding-top: 0;
					border-top: unset;
				}
			}

			.center {
				@media (max-width: $mobile-xl) {
					width: 100%;
					padding-top: 0;
					border-top: unset;
				}
			}

			.right {
				@media (max-width: $mobile-xl) {
					width: 100%;
					padding-top: 0;
					border-top: unset;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/SiteFooter.vue